import { DATE_RANGE_NUMERIC_VALUES } from 'applicationTable/applicationUtils';

export const getDateRangeNumber = () => {
  const storedSettings = JSON.parse(
    localStorage?.getItem('applicationsTableSettings') || '{}',
  );
  const defaultDateFromNumber = storedSettings?.dateRange
    ? DATE_RANGE_NUMERIC_VALUES[storedSettings.dateRange]
    : 1;

  return defaultDateFromNumber || null;
};

export const getIncludePartnerChannel = () => {
  const storedSettings = JSON.parse(
    localStorage?.getItem('applicationsTableSettings') || '{}',
  );
  const defaultIncludePartnerChannel = Boolean(
    storedSettings?.includePartnerChannel,
  );

  return defaultIncludePartnerChannel;
};
